<template>
  <div class="forgot-password">
    <div v-if="!passwordLinkSent">
      <h3>Forgot Password</h3>
      <div class="input-wrapper">
        <label>Email</label>
        <input
          type="text"
          class="input-box"
          id="userEmail"
          placeholder="Enter your email"
          v-model="userEmail"
          @change="onEmailChange"
          @blur="onEmailChange"
        />
        <span class="error-wrapper" v-if="emailErrorMsg !== ''">
          {{ emailErrorMsg }}
        </span>
      </div>

      <div class="error-wrapper" v-if="emailNotRegistered">
        Oops! The email is not registered with us
      </div>

      <div class="error-wrapper" v-if="emailSomethingWrong">
        Something went wrong, Please try later
      </div>

      <V-Button
        className="action-btn"
        :text="'RECOVER PASSWORD'"
        :loading="loading"
        :callback="forgotPassword"
        :newLoader="true"
      >
      </V-Button>

      <div class="switch-section">
        <span class="anchor-link" @click="setShowSignIn">Go Back to Login</span>
      </div>
    </div>
    <div class="reset-password-success" v-if="passwordLinkSent">
      <div class="text">
        Password reset link has been sent to your registered email address.
        Please check your email and follow the instructions.
      </div>
      <div class="success-ok-btn" @click="setShowSignIn">ok</div>
    </div>
    <div class="privacyCont" v-if="!passwordLinkSent">
      This site is protected by reCAPTCHA and the Google
      <a
        href="https://policies.google.com/privacy"
        target="_blank"
        rel="noopener noreferrer"
        >&nbsp;Privacy Policy&nbsp;</a
      >and
      <a
        href="https://policies.google.com/terms"
        target="_blank"
        rel="noopener noreferrer"
        >&nbsp;Terms of Service&nbsp;</a
      >apply.
    </div>
  </div>
</template>

<script>
import { URLS } from '../../assets/util/constants/constants'
import { post } from '../../assets/util/rest'
import { generateCaptchaToken } from '../../assets/util/commonUtil'
import button from '@/components/Button'

export default {
  name: 'ForgetPasswordView',
  props: ['showPopup', 'validateEmail', 'setShowSignIn'],
  components: {
    'V-Button': button
  },
  data: function() {
    return {
      userEmail: '',
      emailErrorMsg: '',
      emailNotRegistered: false,
      emailSomethingWrong: false,
      passwordLinkSent: false,
      loading: false
    }
  },
  methods: {
    onEmailChange() {
      this.emailErrorMsg = this.validateEmail(this.userEmail)
    },
    forgotPassword() {
      const thisObj = this
      this.emailErrorMsg = this.validateEmail(this.userEmail)
      if (this.emailErrorMsg == '') {
        this.loading = true
        generateCaptchaToken().then(function(token) {
          if (token != null) {
            post(
              URLS.forgotPassword +
                '?email=' +
                thisObj.userEmail +
                '&token=' +
                token
            )
              .then(res => {
                res.json().then(response => {
                  if (response == 'true') {
                    thisObj.passwordLinkSent = true
                  } else if (response == 'false') {
                    thisObj.emailNotRegistered = true
                  } else {
                    thisObj.emailSomethingWrong = true
                  }
                  thisObj.loading = false
                })
              })
              .catch(() => {
                thisObj.loading = false
              })
          } else {
            thisObj.emailSomethingWrong = true
          }
        })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.forgot-password {
  display: flex;
  flex-direction: column;
  min-height: 278px;
  justify-content: space-between;

  h3 {
    margin: 0 0 10px 0;
    color: #464545;
    letter-spacing: 0.3px;
  }

  .action-btn {
    background: #abd46e !important;
    border-color: #abd46e !important;
    border: 0 !important;
    box-shadow: none !important;
    padding: 0;
  }
  .switch-section {
    .anchor-link {
      font-family: 'Figtree-Medium';
      letter-spacing: -0.2px;
    }
  }
  .reset-password-success {
    .text {
      font-size: 18px;
      line-height: 22px;
      text-align: center;
      color: $text-dark;
    }
    .success-ok-btn {
      text-align: center;
      font-size: 15px;
      width: 100px;
      text-transform: uppercase;
      background: #abd46e !important;
      color: #fff;
      border-radius: 3px;
      cursor: pointer;
      border: none;
      line-height: 40px;
      height: 40px;
      outline: none;
      margin: 10px auto 0;
    }
  }
  .privacyCont {
    font-size: 13px;
    line-height: normal;
    margin-bottom: 8px;
    text-align: center;

    a {
      text-decoration: none;
    }
  }
}
</style>
